import { LOCAL_STORAGE_STATE_PERSIST } from '@/utils/constants/checkin.constants';

export const getInitialState = () => {
  const savedData = localStorage.getItem(LOCAL_STORAGE_STATE_PERSIST);

  if (savedData) {
    const parsedData = JSON.parse(savedData);

    if (parsedData?.questionnaire?.medications !== '') {
      return ({
        received: [],
        toSend: [],
        medications: parsedData?.questionnaire?.medications
      });
    }
  }

  return ({
    received: [],
    toSend: [],
    medications: ''
  });
};

export const state = getInitialState();
